import React from "react";
import Link from "next/link";
import classNames from "classnames";
import { menuItems } from "./config";
import { DesktopMenuProps } from "./types";
import classes from "./desktop-menu.module.scss";

export const DesktopMenu = ({ className, activeItem }: DesktopMenuProps) => {
    return (
        <nav className={classNames(classes["desktop-menu"], className)}>
            <ul className={classes["desktop-menu__list"]}>
                {menuItems.map(({ title, link }) => (
                    <li key={link} className={classes["desktop-menu__item"]}>
                        <Link
                            href={link}
                            className={classNames(classes["desktop-menu__link"], {
                                [classes["desktop-menu__link--active"]]: activeItem.link === link
                            })}
                        >
                            {title}
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
};